import { lazy, Suspense, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { track } from "../../lib/analytics";

const WidgetPanel = lazy(() => import("./WidgetPanel"));

export function AssistantWidget() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { document.documentElement.classList.toggle("aiw-lock", open); }, [open]);
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    const onOpen = () => { setLoaded(true); setOpen(true); };
    window.addEventListener("keydown", onKey); window.addEventListener("si-open-assistant", onOpen);
    return () => { window.removeEventListener("keydown", onKey); window.removeEventListener("si-open-assistant", onOpen); };
  }, []);
  if (pathname.startsWith("/admin")) return null;
  const toggle = () => { setLoaded(true); setOpen((o) => !o); if (!open) track("assistant_widget_open", { page: pathname }); };
  return (
    <div className="aiw" data-testid="ai-widget">
      {!open && (
        <button type="button" className="aiw-fab" onClick={toggle} aria-label="Ask SourcingIndia AI" aria-expanded={open} data-testid="ai-widget-button">
          <span className="aiw-ico"><Sparkles size={18} strokeWidth={1.8} /></span><span className="aiw-lbl">Ask SourcingIndia AI</span>
        </button>
      )}
      {loaded && <Suspense fallback={null}><WidgetPanel open={open} onClose={() => setOpen(false)} /></Suspense>}
    </div>
  );
}
